import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";

import Header from "../components/ContainerHeader";
import Form from "../components/packageNew/Form";

import {
  setActiveHost,
  setActiveServer,
  setActiveOrganization,
  setActivePackage
} from "../actions/activeActions";

const PackageNew = ( inputProps ) => {

  let {
      history,
      activeHost,
      activeServer,
      activeOrganization,
      activePackage
  } = inputProps;

  // debugger;

  if (activeOrganization) {
      let hostId = activeHost ? activeHost.id: null;
      let serverId = activeServer ? activeServer.id : null;
      return (
          <div className="flex-col">
              <Header title="Přidat nový package"/>
              <Form
                  hostId={hostId}
                  serverId={serverId}
                  organizationId={activeOrganization.id}
                  history={history}
                  packageObject={activePackage}
                  initialValues={activePackage}
              />
          </div>
      );
  }
  return <div />;
};

export default compose(
  connect(
    (inputState) => {
        let {
            active: { activeHost, activeServer, activeOrganization, activePackage }
        } = inputState;

        // debugger;

        return {
      activeHost,
      activeServer,
      activeOrganization,
      activePackage
    }},
    { setActiveHost, setActiveServer, setActiveOrganization, setActivePackage }
  ),
  lifecycle({
    componentWillUnmount() {
      const {
        setActiveHost,
        setActiveServer,
        setActiveOrganization,
        setActivePackage
      } = this.props;

      setActiveHost(null);
      setActiveServer(null);
      setActiveOrganization(null);
      setActivePackage(null);
    }
  })
)(PackageNew);



// WEBPACK FOOTER //
// ./src/pages/PackageNew.js